module.exports = __webpack_public_path__ + "img/1538641149.2701405d.jpg";